export default __webpack_public_path__ + "static/media/bookIcon.22e37a9e.svg";